import { module } from 'stereomodularjs';
import GLightbox from 'glightbox';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let glightboxLinks = document.querySelectorAll('[data-module="GLightbox"]');
        glightboxLinks.forEach(el => {
            el.setAttribute('data-glightbox', ".js-" + el.getAttribute('data-mid') + "-el");
            let elLinks = el.querySelectorAll('a');
            elLinks.forEach(elLink => {
                elLink.classList.add('js-' + el.getAttribute('data-mid') + '-el');
                elLink.classList.add('js-prevent');
            });
        });
        const glightbox = GLightbox({
            selector: this.el.getAttribute('data-glightbox')
        });
        glightbox.on('open', () => {
            glightbox.elements[glightbox.elements.length - 1].instance.element.classList.add('is-glightbox-focus-back');
            //console.log(glightbox);
        })
        glightbox.on('close', () => {
            document.querySelector('.is-glightbox-focus-back').focus();
            document.querySelector('.is-glightbox-focus-back').classList.remove('is-glightbox-focus-back');
        })
    }

    destroy() {
        if (this.glightbox) {
            this.glightbox.close();
            this.glightbox.destroy();
            this.glightbox = null;
        }
    }
}
